import { NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '@backbase/ui-ang/icon';
import { FormsModule } from '@angular/forms';
import { BaseClassesModule } from '@backbase/ui-ang/base-classes';
import { FocusModule } from '@backbase/ui-ang/focus';

import { DropdownSingleSelectComponent } from './dropdown-single-select.component';
import { DropdownSingleSelectOptionComponent } from './dropdown-single-select-option.component';

/**
 * Angular module that provides dropdown single select functionality.
 *
 * @remarks
 * This module exports {@link DropdownSingleSelectComponent} and {@link DropdownSingleSelectOptionComponent}
 * along with all necessary dependencies. Import this module to use dropdown components in your application.
 *
 * @example
 *
 * ```typescript
 * import { DropdownSingleSelectModule } from '@backbase/ui-ang/dropdown-single-select';
 *
 * @NgModule({
 *   imports: [DropdownSingleSelectModule],
 *   // ...
 * })
 * export class MyModule {}
 * ```
 */
@NgModule({
  imports: [IconModule, FormsModule, BaseClassesModule, FocusModule, NgClass],
  declarations: [DropdownSingleSelectComponent, DropdownSingleSelectOptionComponent],
  exports: [DropdownSingleSelectComponent, DropdownSingleSelectOptionComponent],
})
export class DropdownSingleSelectModule {}
